import template from './repair-type.jade';
import repairType from './../../../enums/repair-type';

export default angular.module('cian.addForm.repairType', []).directive('cianAfAboutObjectRepairType', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.items = repairType;
    if (!this.ad.repairType) {
      this.ad.repairType = this.items[0].value;
    }
  },
  controllerAs: 'repairType',
  template,
})).name;
